"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var BaseChart_1 = require("./BaseChart");
var BarChart = /** @class */ (function (_super) {
    __extends(BarChart, _super);
    function BarChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BarChart.prototype.hexToRgb = function (hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    };
    BarChart.prototype.getBackgroundColor = function (hex) {
        var rgb = this.hexToRgb(hex);
        return "rgba(".concat(rgb.r, ",").concat(rgb.g, ",").concat(rgb.b, ", 0.4)");
    };
    BarChart.prototype.mapData = function () {
        var _this = this;
        var data = _super.prototype.mapData.call(this);
        data.datasets[0].borderColor = this.getColors();
        data.datasets[0].borderWidth = 1;
        data.datasets[0].backgroundColor = this.getColors().map(function (color) {
            return _this.getBackgroundColor(color);
        });
        return data;
    };
    BarChart.prototype.getChartType = function () {
        return "bar";
    };
    BarChart.prototype.getOptions = function () {
        return __assign(__assign({}, _super.prototype.getOptions.call(this)), { scales: {
                yAxes: [{
                        ticks: {
                            suggestedMin: 0,
                            fontSize: 8
                        }
                    }],
                xAxes: [{
                        ticks: {
                            display: false
                        },
                        gridLines: {
                            display: false
                        }
                    }],
            } });
    };
    BarChart.prototype.getLabelColorStyle = function (datasetIndex) {
        var color = this.getColors()[datasetIndex];
        return {
            backgroundColor: this.getBackgroundColor(color),
            border: "solid 1px ".concat(color)
        };
    };
    BarChart.prototype.render = function () {
        return React.createElement("div", { className: "chartjs" },
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { xs: "6" }, this.renderChart()),
                React.createElement(reactstrap_1.Col, { xs: "6", style: { marginBottom: "4px" } }, this.renderLabels())));
    };
    return BarChart;
}(BaseChart_1.default));
exports.default = BarChart;
//# sourceMappingURL=BarChart.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/charts/chartjs/BarChart.js
// module id = 2263
// module chunks = 0